<template>
  <div class="guarantee-applicant">
    <MyTitle theTitle="申请人" />
      <van-cell-group class="fd-com-scroll">
        <van-field
          v-model="formData.sqrlxText"
          required
          clearable
          readonly
          label="申请人类型"
          right-icon="arrow"
          placeholder="请选择类型"
          @click="selectSqrlx"
        ></van-field>
        <van-popup v-model="showSqrlx" position="bottom">
          <van-picker
            show-toolbar
            :columns="columnsRYLX"
            :default-index="0"
            @cancel="showSqrlx = false"
            @confirm="onSelectSqrlx"
          ></van-picker>
        </van-popup>
        <div v-if="sqrLx == 1">
          <van-field
            v-model="formData.xm"
            required
            label="姓名"
            placeholder="请输入姓名"
          ></van-field>
          <van-field
            v-model="formData.zjlxText"
            required
            readonly
            label="证件类型"
            right-icon="arrow"
            placeholder="请选择证件类型"
            @click="showZJLXPicker = true"
          ></van-field>
          <van-popup v-model="showZJLXPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_105000"
              :default-index="0"
              @cancel="showZJLXPicker = false"
              @confirm="onZJLXConfirm"
            ></van-picker>
          </van-popup>
          <!--                    只有选择身份证的时候才显示证件有效期 -->
          <section class="fd-com-section" v-if="formData.zjlx == 1">
            <div class="fd-com-title">
              证件有效期
            </div>
            <van-field
              v-model="formData.dtZjyxqKsrqText"
              required
              clearable
              readonly
              right-icon="arrow"
              label="开始日期"
              placeholder="请选择开始日期"
              @click="showZjyxqKsrqDatePicker = true"
            ></van-field>
            <van-popup v-model="showZjyxqKsrqDatePicker" position="bottom">
              <van-datetime-picker
                v-model="zjyxqKsrqCurrentDate"
                type="date"
                @cancel="showZjyxqKsrqDatePicker = false"
                @confirm="onZjyxqKsrqDatePickerConfirm"
              ></van-datetime-picker>
            </van-popup>
            <van-field
              v-model="formData.dtZjyxqJsrqText"
              required
              clearable
              readonly
              right-icon="arrow"
              label="结束日期"
              placeholder="请选择结束日期"
              @click="showIndate = true"
            ></van-field>
            <van-popup v-model="showZjyxqJsrqDatePicker" position="bottom">
              <van-datetime-picker
                v-model="zjyxqJsrqCurrentDate"
                type="date"
                @cancel="showZjyxqJsrqDatePicker = false"
                @confirm="onZjyxqJsrqDatePickerConfirm"
              ></van-datetime-picker>
            </van-popup>
            <!--                    证件有效期列表 -->
            <van-popup v-model="showIndate" position="bottom">
              <van-picker
                show-toolbar
                :columns="columnsIndate"
                @cancel="showIndate = false"
                @confirm="onIndateConfirm"
              ></van-picker>
            </van-popup>
          </section>
          <van-field
            v-model="formData.zjhm"
            required
            label="证件号码"
            placeholder="请输入证件号码"
            @input="identifyAnalyzer"
          ></van-field>
          <van-field
            v-if="formData.zjlx == 1"
            v-model="formData.dtSqrBirthdayText"
            required
            clearable
            readonly
            right-icon="arrow"
            label="出生日期"
            placeholder="请选择出生日期"
            @click="showDatePicker = true"
          ></van-field>
          <van-field
            v-if="formData.zjlx != 1"
            v-model="formData.dtSqrBirthdayText"
            required
            clearable
            readonly
            right-icon="arrow"
            label="出生日期"
            placeholder="请选择出生日期"
            @click="showDatePicker = true"
          ></van-field>
          <van-popup v-model="showDatePicker" position="bottom">
            <van-datetime-picker
              v-model="currentDate"
              type="date"
              :min-date="minDate"
              :max-date="maxDate"
              @cancel="showDatePicker = false"
              @confirm="onDatePickerConfirm"
            ></van-datetime-picker>
          </van-popup>
          <van-field
            v-if="formData.zjlx == 1"
            v-model="formData.nl"
            required
            clearable
            label="年龄"
            placeholder="请输入年龄"
          ></van-field>
          <van-field
            v-if="formData.zjlx != 1"
            v-model="formData.nl"
            required
            clearable
            label="年龄"
            placeholder="请输入年龄"
          ></van-field>
          <van-field v-if="formData.zjlx === 1" required label="性别">
            <van-radio-group
              slot="input"
              v-model="formData.xb">
              <van-radio
                v-for="item in codeList_110000"
                :name="item.keyId"
                :key="item.keyId">
                {{ item.text }}
              </van-radio>
            </van-radio-group>
          </van-field>
          <van-field v-else required label="性别">
            <van-radio-group
              slot="input"
              v-model="formData.xb">
              <van-radio
                v-for="item in codeList_110000"
                :name="item.keyId"
                :key="item.keyId">
                {{ item.text }}
              </van-radio>
            </van-radio-group>
          </van-field>
          <van-field
            v-model="formData.mzText"
            required
            readonly
            label="民族"
            right-icon="arrow"
            placeholder="请选择民族"
            @click="showMZPicker = true"
          ></van-field>
          <van-popup v-model="showMZPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_120000"
              :default-index="0"
              @cancel="showMZPicker = false"
              @confirm="onMZConfirm"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.sjhm"
            required
            label="手机号码"
            placeholder="请输入手机号码"
          ></van-field>
          <!-- <van-field
                            v-model="formData.gddh"
                            label="固定电话"
                            placeholder="请输入固定电话"
                    ></van-field> -->
          <section class="fd-com-section">
            <div class="fd-com-title">
              固定电话
            </div>
            <van-field
              v-model="formData.cGh1"
              label="区号"
              placeholder="请输入区号"
            ></van-field>
            <van-field
              v-model="formData.cGh2"
              label="电话号码"
              placeholder="请输入电话号码"
            ></van-field>
            <van-field
              v-model="formData.cGh3"
              label="分机号"
              placeholder="请输入分机号"
            ></van-field>
          </section>
          <van-field
            v-model="formData.jcjzd"
            required
            label="经常居住地"
            placeholder="请输入经常居住地"
          ></van-field>
        </div>
        <div v-if="sqrLx == 2">
          <van-field
            v-model="formData.qymc"
            required
            label="单位名称"
            placeholder="请输入单位名称"
          ></van-field>

          <!--                    <van-field
                            v-model="formData.tyshxydm"
                            required
                            label="统一社会信用代码"
                            placeholder="请输入统一社会信用代码"
                    ></van-field>-->
          <van-field
            v-model="formData.nZzlxText"
            required
            readonly
            label="证照类型"
            right-icon="arrow"
            placeholder="请选择证照类型"
            @click="showZZPicker = true"
          ></van-field>
          <van-popup v-model="showZZPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_109000"
              :default-index="nZzlx"
              @cancel="showZZPicker = false"
              @confirm="onZZConfirm"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.tyshxydm"
            required
            label="证照号码"
            placeholder="请输入证照号码"
          ></van-field>

          <van-field
            v-model="formData.dwxzText"
            required
            readonly
            label="单位性质"
            right-icon="arrow"
            placeholder="请选择单位性质"
            @click="showGZDWPicker = true"
          ></van-field>
          <van-popup v-model="showGZDWPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_108000"
              :default-index="0"
              @cancel="showGZDWPicker = false"
              @confirm="onGZDWConfirm"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.fddbr"
            required
            label="法定代表人"
            placeholder="请输入法定代表人姓名"
          ></van-field>
          <van-field
            v-model="formData.sjhm"
            required
            label="手机号码"
            placeholder="请输入手机号码"
          ></van-field>
          <!-- <van-field
                            v-model="formData.gddh"
                            label="固定电话"
                            placeholder="请输入固定电话"
                    ></van-field> -->
          <section class="fd-com-section">
            <div class="fd-com-title">
              固定电话
            </div>
            <van-field
              v-model="formData.cGh1"
              label="区号"
              placeholder="请输入区号"
            ></van-field>
            <van-field
              v-model="formData.cGh2"
              label="电话号码"
              placeholder="请输入电话号码"
            ></van-field>
            <van-field
              v-model="formData.cGh3"
              label="分机号"
              placeholder="请输入分机号"
            ></van-field>
          </section>
          <van-field
            v-model="formData.dwdz"
            required
            label="单位地址"
            placeholder="请输入单位地址"
          ></van-field>
        </div>
        <div v-if="sqrLx == 3">
          <van-field
            v-model="formData.qymc"
            required
            label="单位名称"
            placeholder="请输入单位名称"
          ></van-field>

          <!--                    <van-field
                            v-model="formData.tyshxydm"
                            required
                            label="统一社会信用代码"
                            placeholder="请输入统一社会信用代码"
                    ></van-field>-->
          <van-field
            v-model="formData.nZzlxText"
            required
            readonly
            label="证照类型"
            right-icon="arrow"
            placeholder="请选择证照类型"
            @click="showZZPicker = true"
          ></van-field>
          <van-popup v-model="showZZPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_109000"
              :default-index="nZzlx"
              @cancel="showZZPicker = false"
              @confirm="onZZConfirm"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.tyshxydm"
            required
            label="证照号码"
            placeholder="请输入证照号码"
          ></van-field>

          <van-field
            v-model="formData.dwxzText"
            required
            readonly
            label="单位性质"
            right-icon="arrow"
            placeholder="请选择单位性质"
            @click="showGZDWPicker = true"
          ></van-field>
          <van-popup v-model="showGZDWPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_108000"
              :default-index="0"
              @cancel="showGZDWPicker = false"
              @confirm="onGZDWConfirm"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.zyfzr"
            required
            label="主要负责人"
            placeholder="请输入主要负责人姓名"
          ></van-field>
          <van-field
            v-model="formData.sjhm"
            required
            label="手机号码"
            placeholder="请输入手机号码"
          ></van-field>
          <!-- <van-field
                            v-model="formData.gddh"
                            label="固定电话"
                            placeholder="请输入固定电话"
                    ></van-field> -->
          <section class="fd-com-section">
            <div class="fd-com-title">
              固定电话
            </div>
            <van-field
              v-model="formData.cGh1"
              label="区号"
              placeholder="请输入区号"
            ></van-field>
            <van-field
              v-model="formData.cGh2"
              label="电话号码"
              placeholder="请输入电话号码"
            ></van-field>
            <van-field
              v-model="formData.cGh3"
              label="分机号"
              placeholder="请输入分机号"
            ></van-field>
          </section>
          <van-field
            v-model="formData.dwdz"
            required
            label="单位地址"
            placeholder="请输入单位地址"
          ></van-field>
        </div>
      </van-cell-group>
      <div class="fd-com-btn-container">
        <van-button
          v-if="sqrId"
          type="info"
          round
          :disabled="!saveBtnClickable"
          @click="addSqrAndReturn"
        >
          确定
        </van-button>
        <van-button
          v-if="!sqrId"
          type="info"
          round
          plain
          :disabled="!saveBtnClickable"
          @click="addSqrAndReturn"
        >
          添加
        </van-button>
        <van-button
          v-if="!sqrId"
          type="info"
          round
          :disabled="!saveBtnClickable"
          @click="addSqrAndContinue"
        >
          确认并继续添加
        </van-button>
      </div>
  </div>
</template>

<script>
import MyTitle from "../../../components/common/myTitle";
import { columnsRYLX, columnIsndate } from "../../../utils/option.js";
import validate from "@/utils/validator/validator";
import {
  typeRylx,
  typeMz,
  typeZzlx,
  typeSfzjlx,
  typeGzdwlx,
} from "../../../filters/index";
import {
  PhoneRule,
  ZjhmRule,
  XmRule,
  mzRule,
  xbRule,
  NlRule,
  zjlxRule,
  TxdzRule,
  QymcRule,
  nZzlxRule,
  CQyzzjgdmRule,
  // 单位性质
  dwxzRule,
  QyfrRule,
  QhRule, // 区号
  DhhmRule, //电话号码
  FjhRule, // 分机号
  // 证件有效期开始日期
  zjyxqKsrqRule,
  // 证件有效期结束日期
  zjyxqJsrqRule,
} from "@/utils/validator/rules";
import {
  addDbSqr,
  addSqr,
  getSqrbyIdOld,
  getSqrById,
  getBgdbzt,
} from "../../../api/guarantee";

import { dateFormat } from "../../../utils/dateFormatter";
import { checkIdentify, getIDData } from "../../../utils/common";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      dbid: "",
      sqrId: "",
      formData: {
        // 姓名
        xm: "",
        // 性别
        xb: "1",
        // 民族
        mz: "1",
        mzText: "汉族", // 民族文字描述
        // 年龄
        nl: "",
        dtSqrBirthday: "", // 申请人出生日期,
        dtSqrBirthdayText: "", // 申请人出生日期文字描述
        // 证件类型
        zjlx: "1",
        // 证件类型汉字描述
        zjlxText: "居民身份证",
        // 证件号码
        zjhm: "",
        // 固定电话
        gddh: "",
        // 手机号码
        sjhm: "",
        // 经常居住地
        jcjzd: "",
        // 单位名称
        qymc: "",

        // 证照类型
        nZzlx: 4,
        // 证照号码
        nZzlxText: "社会统一信用代码证",

        // 统一社会信用代码
        tyshxydm: "",
        // 单位性质
        dwxz: "",
        dwxzText: "", // 单位性质文字描述
        // 法定代表人
        fddbr: "",
        // 单位地址
        dwdz: "",
        // 主要负责人
        zyfzr: "",
        // 申请人类型描述
        sqrlxText: "自然人",
        cGh1: "",
        cGh2: "",
        cGh3: "",
        // 申请人证件有效期开始日期
        dtZjyxqKsrq: "",
        // 申请人证件有效期开始日期文字描述
        dtZjyxqKsrqText: "",
        // 申请人证件有效期结束日期
        dtZjyxqJsrq: "",
        // 申请人证件有效期结束日期文字描述
        dtZjyxqJsrqText: "",
        // 是否长期有效
        longTerm: false,
      },
      postData: {
        cSqrlx: "", // 申请人类型
        cSqrxm: "", // 申请人姓名
        nMz: "", // 民族
        cSqrxb: "", // 性别
        nNl: "", // 年龄
        dtSqrBirthday: "", // 申请人出生日期
        cZjlx: "", // 证件类型
        cZjh: "", // 证件号

        nZzlx: "", // 证照类型
        nZzlxText: "", //证照类型名称

        cGh: "", // 固话
        cPhoneno: "", // 电话号
        cJtdwdz: "", // 家庭单位地址,接口字段废弃,使用下方通讯地址字段
        cTxdz: "", // 通讯地址,所有地址用这个字段提交
        cQymc: "", // 单位名称
        cQyzzjgdm: "", // 企业组织机构代码(也就是统一社会信用代码)
        cDwxz: "", // 单位性质
        cQyfr: "", // 企业法人(也是主要负责人)
      },
      showSqrlx: false,
      actionsSqrlx: [
        { id: 1, name: "自然人" },
        { id: 2, name: "法人" },
        { id: 3, name: "非法人组织" },
      ],
      nZzlx: 3,
      sqrLx: 1,
      columnsRYLX: columnsRYLX,
      // 有效期列表
      columnsIndate: Object.freeze(columnIsndate),
      // 显示证件有效期列表
      showIndate: false,
      showZJLXPicker: false,
      showDatePicker: false,
      currentDate: new Date(),
      // 证件有效期开始日期
      showZjyxqKsrqDatePicker: false,
      zjyxqKsrqCurrentDate: new Date(),
      // 证件有效期结束日期
      showZjyxqJsrqDatePicker: false,
      zjyxqJsrqCurrentDate: new Date(),
      showMZPicker: false,
      showZZPicker: false,
      showGZDWPicker: false,
      minDate: new Date("1800-01-01"),
      maxDate: new Date(),
      saveBtnClickable: true, // 保存按钮是否可以点击
      fromSQBG: sessionStorage.getItem("fromSQBG"),
      cDbzt: "",
    };
  },
  components: {
    MyTitle,
  },
  computed: {
    ...mapGetters([
      "codeList_105000",
      "codeList_108000",
      "codeList_110000",
      "codeList_120000",
      "codeList_109000",
    ]),
  },
  methods: {
    //修改重新申请的状态
    changeDbstate: function () {
      if (this.fromSQBG !== "true" && this.cDbzt === "6") {
        getBgdbzt({ dbid: this.dbid })
          .then((res) => {})
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    selectSqrlx() {
      this.showSqrlx = true;
    },
    onSelectSqrlx(item) {
      if (item.keyId == 1) {
        this.formData.xb = "1";
        this.formData.mz = 1;
        this.formData.mzText = "汉族";
        this.formData.zjlx = 1;
        this.formData.zjlxText = "居民身份证";
      } else {
        this.clearSQRData();
        this.formData.nZzlx = 4;
        this.formData.nZzlxText = "社会统一信用代码证";
      }
      this.initSqrData(sessionStorage.getItem("sqrId"));
      this.showSqrlx = false;
      this.formData.sqrlxText = item.text;
      this.sqrLx = item.keyId;
    },
    addSqrInfo: function () {
      this.saveBtnClickable = false;
      let sqrId = sessionStorage.getItem("sqrId");
      if (
        sqrId != "" &&
        sqrId != undefined &&
        sqrId != null &&
        sqrId != "undefined"
      ) {
        // 如果sqrId有值代表是更新
        this.postData.cId = sqrId;
        this.postData.nValid = 1;
        this.postData.cDbId = this.dbid;
      }
      this.postData.cSqrlx = this.sqrLx;
      this.postData.cPhoneno = this.formData.sjhm;
      let ghList = [];
      for (let i = 1; i < 4; i++) {
        if (this.formData[`cGh${i}`]) {
          ghList.push(this.formData[`cGh${i}`]);
        }
      }
      this.postData.cGh = ghList.join("-");
      if (this.sqrLx == 1) {
        this.postData.cSqrxm = this.formData.xm;
        this.postData.cZjlx = this.formData.zjlx;
        this.postData.cZjh = this.formData.zjhm;
        this.postData.dtSqrBirthday = this.formData.dtSqrBirthday;
        this.postData.nNl = this.formData.nl;
        this.postData.cSqrxb = this.formData.xb;
        this.postData.nMz = this.formData.mz;
        this.postData.cTxdz = this.formData.jcjzd;
        // 证件有效期开始日期
        this.postData.dtZjyxqKsrq = this.formData.dtZjyxqKsrq;
        // 证件有效期结束日期
        this.postData.dtZjyxqJsrq = this.formData.dtZjyxqJsrq;
      } else {
        this.postData.nZzlx = this.formData.nZzlx;
        this.postData.nZzlxText = this.formData.nZzlxText;

        this.postData.cQymc = this.formData.qymc;
        this.postData.cQyzzjgdm = this.formData.tyshxydm;
        this.postData.cDwxz = this.formData.dwxz;
        this.postData.cTxdz = this.formData.dwdz;
      }
      if (this.sqrLx == 2) {
        this.postData.cQyfr = this.formData.fddbr;
      }
      if (this.sqrLx == 3) {
        this.postData.cQyfr = this.formData.zyfzr;
      }

      var fnGet = this.fromSQBG === "true" ? addSqr : addDbSqr;
      return fnGet({ dbid: this.dbid }, this.postData)
        .then((res) => {
          this.changeDbstate();
          this.$notify({
            type: "success",
            message: "操作成功",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
      /*return this.$axios.post('ssbq/api/xcx/dbSqr?dbid=' + this.dbid, this.postData)
                    .then(res => {
                        this.$notify({
                            type: 'success',
                            message: '操作成功'
                        });
                    }).catch(function (error) {
                        console.log(error)
                    });*/
    },
    addSqrAndReturn: function () {
      const validated = this.validateFormData();
      validated
        .then(() => {
          this.addSqrInfo().then(() => {
            this.$router.push("/guaranteeInfo");
          });
        })
        .catch(() => {
          console.log("请完整填写表单数据");
        });
    },
    addSqrAndContinue: function () {
      const validated = this.validateFormData();
      validated
        .then(() => {
          this.addSqrInfo().then(() => {
            // this.clearSQRData();
            setTimeout(() => {
              window.location.reload();
            }, 500);
          });
        })
        .catch(() => {
          console.log("请完整填写表单数据");
        });
    },
    onZJLXConfirm: function (value) {
      this.formData.zjlx = value.keyId;
      this.formData.zjlxText = value.text;
      this.showZJLXPicker = false;
    },
    /**
     * 证件有效期开始日期确认时间
     * */
    onZjyxqKsrqDatePickerConfirm: function () {
      this.zjyxqKsrqCurrentDate = new Date(
        this.zjyxqKsrqCurrentDate.setHours(8)
      );
      this.formData.dtZjyxqKsrq = this.zjyxqKsrqCurrentDate;
      this.showZjyxqKsrqDatePicker = false;
      this.formData.dtZjyxqKsrqText = dateFormat(
        this.formData.dtZjyxqKsrq,
        "yyyy-MM-dd"
      );
      // 如果结束日期小于开始日期，则将结束日期设置成开始日期
      if (
        this.zjyxqJsrqCurrentDate &&
        this.zjyxqJsrqCurrentDate.getTime() <
          this.zjyxqKsrqCurrentDate.getTime()
      ) {
        this.zjyxqJsrqCurrentDate = this.zjyxqKsrqCurrentDate;
        this.onZjyxqJsrqDatePickerConfirm();
      }
    },
    /**
     * 证件有效期结束日期确认时间
     * */
    onZjyxqJsrqDatePickerConfirm: function () {
      this.zjyxqJsrqCurrentDate = new Date(
        this.zjyxqJsrqCurrentDate.setHours(8)
      );
      this.formData.dtZjyxqJsrq = this.zjyxqJsrqCurrentDate;
      this.showZjyxqJsrqDatePicker = false;
      this.formData.dtZjyxqJsrqText = dateFormat(
        this.formData.dtZjyxqJsrq,
        "yyyy-MM-dd"
      );
      // 如果开始日期大于结束日期，则将开始日期设置成结束日期
      if (
        this.zjyxqKsrqCurrentDate &&
        this.zjyxqKsrqCurrentDate.getTime() >
          this.zjyxqJsrqCurrentDate.getTime()
      ) {
        this.zjyxqKsrqCurrentDate = this.zjyxqJsrqCurrentDate;
        this.onZjyxqKsrqDatePickerConfirm();
      }
    },
    onDatePickerConfirm: function () {
      this.currentDate = new Date(this.currentDate.setHours(8));
      this.formData.dtSqrBirthday = this.currentDate;
      this.showDatePicker = false;
      this.formData.dtSqrBirthdayText = dateFormat(
        this.formData.dtSqrBirthday,
        "yyyy-MM-dd"
      );
    },
    /**
     * 有效期列表确认
     * */
    onIndateConfirm(item) {
      // 长期有效
      if (item.keyId === 1) {
        // 有效期结束日期为长期
        this.formData.dtZjyxqJsrq = "长期";
        // 显示文本为长期
        this.formData.dtZjyxqJsrqText = "长期有效";
        // 证件有效期结束时间置空
        this.zjyxqJsrqCurrentDate = "";
      } else {
        // 选择有效期至，则显示结束日期控件
        this.showZjyxqJsrqDatePicker = true;
      }
      // 隐藏有效期列表弹层
      this.showIndate = false;
    },
    onMZConfirm: function (item) {
      this.formData.mz = item.keyId;
      this.formData.mzText = item.text;
      this.showMZPicker = false;
    },
    onZZConfirm: function (item) {
      console.log("--onZZConfirm 1111", item);
      this.formData.nZzlx = item.keyId;
      this.formData.nZzlxText = item.text;
      this.showZZPicker = false;
    },
    onGZDWConfirm: function (item) {
      this.formData.dwxz = item.keyId;
      this.formData.dwxzText = item.text;
      this.showGZDWPicker = false;
    },
    initSqrData: function (sqrId, firstVisit) {
      if (!sqrId || sqrId == "undefined") {
        return;
      }
      var fnGet = this.fromSQBG === "true" ? getSqrById : getSqrbyIdOld;
      fnGet({ id: sqrId })
        .then((res) => {
          let data = res.data;
          if (firstVisit || this.sqrLx == data.cSqrlx) {
            this.formData.xm = data.cSqrxm;
            this.formData.xb = data.cSqrxb;
            this.formData.mz = data.nMz;
            this.formData.mzText = typeMz(data.nMz);
            this.formData.nl = data.nNl;
            this.formData.dtSqrBirthday = data.dtSqrBirthday;
            this.formData.dtSqrBirthdayText = data.dtSqrBirthday;
            this.formData.zjlx = data.cZjlx;
            this.formData.zjlxText = typeSfzjlx(data.cZjlx);
            this.formData.zjhm = data.cZjh;
            this.formData.gddh = data.cGh;
            let cGh = this.formData.gddh.split("-");
            this.formData.cGh1 = cGh[0];
            this.formData.cGh2 = cGh[1];
            this.formData.cGh3 = cGh[2];
            this.formData.sjhm = data.cPhoneno;
            this.formData.jcjzd = data.cTxdz;
            this.formData.qymc = data.cQymc;
            this.formData.nZzlx = data.nZzlx;
            this.formData.nZzlxText = typeZzlx(data.nZzlx);
            this.formData.tyshxydm = data.cQyzzjgdm;
            this.formData.dwxz = data.cDwxz;
            this.formData.dwxzText = typeGzdwlx(data.cDwxz);
            this.formData.fddbr = data.cQyfr;
            this.formData.dwdz = data.cTxdz;
            this.formData.zyfzr = data.cQyfr;
            this.formData.sqrlxText = typeRylx(data.cSqrlx);
            this.sqrLx = data.cSqrlx;
            // 证件有效期开始日期
            this.formData.dtZjyxqKsrq = data.dtZjyxqKsrq;
            this.formData.dtZjyxqKsrqText = data.dtZjyxqKsrq;
            // 证件有效期结束日期
            this.formData.dtZjyxqJsrq = data.dtZjyxqJsrq;
            this.formData.dtZjyxqJsrqText = data.dtZjyxqJsrq;
          }
        })
        .catch(function (error) {
          console.log(error);
        });

      /* this.$axios.get('ssbq/api/ssdb/sqr?id=' + sqrId)
                    .then(res => {

                    }).catch(function (error) {
                    console.log(error)
                });*/
    },
    clearSQRData: function () {
      let formData = this.formData;
      for (let key in formData) {
        formData[key] = "";
      }
    },
    validateFormData: function () {
      // 校验规则
      let descriptor;
      if (this.sqrLx == 1) {
        // 自然人校验规则
        descriptor = {
          xm: new XmRule(true),
          zjlx: zjlxRule,
        };
        // 证件类型为1，需要验证证件有效期，为了保证校验顺序所以进行这样设置
        if (this.formData.zjlx == 1) {
          descriptor = Object.assign(descriptor, {
            // 证件有效期开始日期
            dtZjyxqKsrq: zjyxqKsrqRule,
            // 证件有效期结束日期
            dtZjyxqJsrq: zjyxqJsrqRule,
          });
        }
        descriptor = Object.assign(descriptor, {
          zjhm: new ZjhmRule(this.formData.zjlx, true),
          // dtSqrBirthday: csrqRule, // 出生日期非必填
          nl: new NlRule(true),
          xb: xbRule,
          mz: mzRule,
          sjhm: new PhoneRule(true),
          // gddh: new GddhRule(false),
          cGh1: new QhRule(false),
          cGh2: new DhhmRule(false),
          cGh3: new FjhRule(false),
          jcjzd: new TxdzRule(this.sqrLx, true),
        });
      }
      if (this.sqrLx == 2) {
        // 法人校验规则
        descriptor = {
          qymc: new QymcRule(true),
          nZzlx: nZzlxRule,
          // tyshxydm: new TyshxydmRule(true),
          tyshxydm: new CQyzzjgdmRule(Number(this.formData.nZzlx), true),
          // 单位性质
          dwxz: dwxzRule,
          fddbr: new QyfrRule(this.sqrLx, true),
          sjhm: new PhoneRule(true),
          // gddh: new GddhRule(false),
          cGh1: new QhRule(false),
          cGh2: new DhhmRule(false),
          cGh3: new FjhRule(false),
          dwdz: new TxdzRule(this.sqrLx, true),
        };
      }
      if (this.sqrLx == 3) {
        // 非法人校验规则
        descriptor = {
          qymc: new QymcRule(true),
          nZzlx: nZzlxRule,
          // tyshxydm: new TyshxydmRule(true),
          tyshxydm: new CQyzzjgdmRule(Number(this.formData.nZzlx), true),
          dwxz: dwxzRule,
          zyfzr: new QyfrRule(this.sqrLx, true),
          sjhm: new PhoneRule(true),
          // gddh: new GddhRule(false),
          cGh1: new QhRule(false),
          cGh2: new DhhmRule(false),
          cGh3: new FjhRule(false),
          dwdz: new TxdzRule(this.sqrLx, true),
        };
      }
      if (this.formData.nl && this.formData.nl > 120) {
        this.$notify("年龄不得大于120");
        return;
      }
      let validated = validate(descriptor, this.formData);
      return validated;
    },
    identifyAnalyzer: function () {
      if (this.formData.zjlx != 1) {
        // 只有身份证才走下方流程
        return;
      }
      let zjhm = this.formData.zjhm;
      let correct = checkIdentify(zjhm);
      if (correct) {
        // 身份证号格式正确, 向服务器查询 生日, 性别, 年龄 信息
        getIDData(zjhm).then((res) => {
          let data = res.data;
          this.formData.dtSqrBirthday = data.cBirthdate;
          this.formData.dtSqrBirthdayText = data.cBirthdate;
          this.formData.nl = data.nAge;
          this.formData.xb = data.cSex;
        });
      }
    },
    initCodeType() {
      /* 证件类型 */
      this.$store.dispatch("GetCodeType", 105000);
      /* 单位性质 */
      this.$store.dispatch("GetCodeType", 108000);
      /* 性别 */
      this.$store.dispatch("GetCodeType", 110000);
      /* 民族 */
      this.$store.dispatch("GetCodeType", 120000);
      /* 证照类型 */
      this.$store.dispatch("GetCodeType", 109000);
    },
  },
  created() {
    this.cDbzt = this.$route.query.cDbzt;
    console.log("--cDbzt 678", this.cDbzt);
    this.initCodeType();
    let sqrId = sessionStorage.getItem("sqrId");
    this.sqrId = sqrId;
    this.initSqrData(sqrId, true);
    let currentDbid = JSON.parse(sessionStorage.getItem("currentDbid"));
    this.dbid = currentDbid;
  },
};
</script>

<style lang="less" scoped>
.guarantee-applicant {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
